export const generateDirectoryPDF = ({ sections, branding }) => {
    const brand = branding || {};
    const brandColor = brand.primaryColor || '#163248';
    const brandSectionBg = brand.sectionBg || '#fde68a';

    const getTypeColor = (type) => {
      const colors = {
        'Робота': '#22c55e',
        'Матеріали': '#eab308',
        'Комплектація': '#3b82f6',
        'Транспорт': '#f97316',
        'Інші послуги': '#a855f7'
      };
      return colors[type] || '#22c55e';
    };

    const getTypeLetter = (type) => {
      const letters = {
        'Робота': 'Р',
        'Матеріали': 'М',
        'Комплектація': 'К',
        'Транспорт': 'Т',
        'Інші послуги': 'І'
      };
      return letters[type] || 'Р';
    };

    const formatNumber = (num) => {
      return num.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    const currentDate = new Date().toLocaleDateString('uk-UA', { 
      day: 'numeric',
      month: 'long', 
      year: 'numeric'
    });

    const totalItems = sections.reduce((sum, s) => sum + (s.items || []).length, 0);

    let html = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title> </title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
    
    * { margin: 0; padding: 0; box-sizing: border-box; }
    
    body { 
      font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif; 
      padding: 30px 40px;
      font-size: 12px; 
      color: #1f2937;
      line-height: 1.4;
      background: white;
    }
    
    /* Header - компактний */
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 2px solid ${brandColor};
    }
    
    .header-left h1 {
      font-size: 22px;
      font-weight: 700;
      color: ${brandColor};
    }
    
    .header-right {
      text-align: right;
    }
    
    .header-right .report-name {
      font-size: 14px;
      font-weight: 600;
      color: ${brandColor};
    }
    
    .header-right .report-date {
      font-size: 12px;
      color: #6b7280;
      margin-top: 2px;
    }
    
    .header-contacts {
      font-size: 11px;
      color: #6b7280;
      line-height: 1.6;
      margin-top: 2px;
    }
    
    .header-logo {
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 0 15px;
    }
    
    /* Table */
    table { 
      width: 100%; 
      border-collapse: collapse;
      margin-bottom: 15px;
      table-layout: fixed;
    }
    
    /* Table header */
    .table-header {
      background: #f9fafb;
      border-bottom: 1px solid #e5e7eb;
    }
    
    .table-header th {
      padding: 8px 10px;
      text-align: left;
      font-weight: 600;
      font-size: 10px;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
    
    .table-header th.center { text-align: center; }
    .table-header th.right { text-align: right; }
    
    /* Section row */
    .section-row td {
      padding: 10px 15px;
      background: ${brandSectionBg};
      font-weight: 700;
      color: #1f2937;
      font-size: 12px;
    }
    
    /* Item row */
    .item-row td {
      padding: 0 10px;
      height: 40px;
      border-bottom: 1px solid #f3f4f6;
      vertical-align: middle;
      font-size: 12px;
    }
    
    /* Type badge - круглий */
    .type-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      font-size: 9px;
      font-weight: 700;
      color: white;
      flex-shrink: 0;
    }
    
    /* Позиція - перенос тексту */
    .item-position {
      color: #374151;
      word-break: break-word;
      overflow-wrap: break-word;
      line-height: 1.3;
    }
    
    .item-unit {
      text-align: center;
      color: #6b7280;
    }
    
    .item-price {
      text-align: right;
      font-weight: 500;
      color: #374151;
    }
    
    /* Footer */
    .footer {
      margin-top: 40px;
      padding-top: 15px;
      border-top: 1px solid #e5e7eb;
      text-align: center;
    }
    
    .footer-text {
      font-size: 10px;
      color: #9ca3af;
      margin-bottom: 5px;
    }
    
    .footer-logo {
      font-family: 'Archivo Black', sans-serif;
      font-size: 18px;
      font-weight: 400;
      color: ${brandColor};
      letter-spacing: 0.5px;
    }
    
    /* Print styles */
    @media print {
      body { 
        padding: 0;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      @page { 
        margin: 12mm;
        size: A4;
      }
      
      title { display: none; }
      
      .section-row td {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      
      .type-badge {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    }
  </style>
  <title></title>
</head>
<body>
  <!-- Header -->
  <div class="header">
    <div class="header-left">
      ${brand.companyName ? `<h1>${brand.companyName}</h1>` : `<h1>Прайс-лист</h1>`}
      ${brand.companyName ? `
        <div class="header-contacts">
          ${brand.managerName ? `<div>${brand.managerName}</div>` : ''}
          ${brand.phone ? `<div>${brand.phone}</div>` : ''}
          ${brand.email ? `<div>${brand.email}</div>` : ''}
          ${brand.website ? `<div>${brand.website}</div>` : ''}
        </div>
      ` : ''}
    </div>
    ${(brand.logoCropped || brand.logoRaw || brand.logo) ? `
      <div class="header-logo">
        <img src="${brand.logoCropped || brand.logoRaw || brand.logo}" alt="" style="max-height: 50px; max-width: 140px; object-fit: contain;" />
      </div>
    ` : ''}
    <div class="header-right">
      <div class="report-name">Прайс-лист</div>
      <div class="report-date">${currentDate}</div>
      <div class="report-date">${totalItems} позицій</div>
    </div>
  </div>
  
  <!-- Table -->
  <table>
    <colgroup>
      <col style="width: 30px;">
      <col style="width: 35px;">
      <col>
      <col style="width: 50px;">
      <col style="width: 90px;">
    </colgroup>
    <thead>
      <tr class="table-header">
        <th></th>
        <th>№</th>
        <th>Позиція</th>
        <th class="center">Од.</th>
        <th class="right">Ціна, грн</th>
      </tr>
    </thead>
    <tbody>
`;

    sections.forEach((section, sIdx) => {
      let itemNumber = 0;
      
      // Section header
      html += `
      <tr class="section-row">
        <td></td>
        <td style="text-align: left;">${sIdx + 1}.</td>
        <td colspan="2">${section.name}</td>
        <td style="text-align: right;">${(section.items || []).length} поз.</td>
      </tr>
`;
      
      // Items
      (section.items || []).forEach((item) => {
        itemNumber++;
        const price = item.price || 0;
        
        html += `
      <tr class="item-row">
        <td style="text-align: center;">
          <span class="type-badge" style="background-color: ${getTypeColor(item.type)}">${getTypeLetter(item.type)}</span>
        </td>
        <td style="text-align: left;">${sIdx + 1}.${itemNumber}</td>
        <td class="item-position">${item.position || '-'}</td>
        <td class="item-unit">${item.unit || ''}</td>
        <td class="item-price">${formatNumber(price)} грн</td>
      </tr>
`;
      });
    });

    html += `
    </tbody>
  </table>
  
  <!-- Footer -->
  <div class="footer">
    <div class="footer-text">Створено на платформі</div>
    <div class="footer-logo">LIHTAR</div>
  </div>
</body>
</html>
`;

    return html;
  };
